import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import type { Access } from 'modules/core/store/models/Access'

import { ImportData } from 'modules/payroll_bundle/lib/PayrollResultContext'

import VirtualList from './VirtualList'

interface Props {
  resultItems: ImportData[]
  selected?: Set<number>
  checkable?: boolean
  onSelectAll?: () => void
  onSelectItem?: (resultItem: ImportData) => void
  getUserFromImportData: (item: ImportData) => Access | null | undefined
  onAssignEmployee: (userId: number, index: number) => void
  onUnAssignEmployee: (userId: number, index: number) => void
  currency: string
}

const GroupBody = ({
  resultItems,
  selected,
  checkable,
  getUserFromImportData,
  onSelectItem,
  onAssignEmployee,
  onUnAssignEmployee,
  currency,
}: Props) => {
  if (resultItems.length === 0) {
    return (
      <Table.Body>
        <Table.Blank
          colSpan={6}
          text={i18n.t('payroll_bundle.payroll_results.results.no_result')}
        />
      </Table.Body>
    )
  }

  return (
    <Table.Body>
      <Table noRadius hideBorder>
        <VirtualList
          resultItems={resultItems}
          itemHeight={80}
          containerHeight={450}
          selected={selected}
          checkable={checkable}
          getUserFromImportData={getUserFromImportData}
          onSelectItem={onSelectItem}
          onAssignEmployee={onAssignEmployee}
          onUnAssignEmployee={onUnAssignEmployee}
          currency={currency}
        />
      </Table>
    </Table.Body>
  )
}

export default GroupBody
